import {
    METHOD_POST,
    SERVER_URL,
    METHOD_GET,
    METHOD_PUT,
    METHOD_DELETE
} from '../constants/api';
import {
    headersAuthSendReceiveJson,
} from '../headers';
import { apiHandleResponse } from '../../util/api';

const getFeeSchedules = (directoryId, isGlobal) => {
    let api = `${SERVER_URL}/api/v2/cms/feeschedule/list-all`;
    if(isGlobal){
        api = `${SERVER_URL}/api/v2/cms/globalfeeschedule/list-all`;
    }
    else if (directoryId !== 'root') {
        api = `${SERVER_URL}/api/v2/cms/feeschedule/list-all`
    }

    return fetch(api, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getHeirarchy = (isGlobal) => {
    const api = isGlobal ? `${SERVER_URL}/api/v1/cms/globaldirectory/hierarchy` : `${SERVER_URL}/api/v1/cms/directory/hierarchy`
    return fetch(api, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const createDirectory = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/directory`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const updateDirectory = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/directory`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const moveDirectoryOrFeeSchedule = (options) => {
    return fetch(`${SERVER_URL}/api/v2/cms/feescheduleanddirectory/move`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const getFeeScheduleDirectoryDependencies = (directoryId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/directory/dependencies/${directoryId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const deleteFeeScheduleDirectory = (directoryId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/directory/${directoryId}`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const searchFeeSchedules = (options) => {
    
    // Always transform type to useGlobalFeeSchedule
    const requestBody = {
        keyword: options?.keyword || '',
        directoryId: options?.directoryId || null,
        useGlobalFeeSchedule: options?.type === 'global'
    };
    
    
    return fetch(`${SERVER_URL}/api/v2/cms/feeschedule/search`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(requestBody),
    }).then(apiHandleResponse).then(response => {
        return response;
    });
};
const searchFeeSchedulesFromClient = (options, targetClient) => {
    return fetch(`${SERVER_URL}/api/v2/cms/feeschedule/search/${targetClient}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const getFeeSchedulesLabelsFromTargetClient = (targetClient,feeScheduleId) => {
    return fetch(`${SERVER_URL}/api/v2/cms/feeschedule/labels/${targetClient}/${feeScheduleId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};
const validateFeeSchedulesLabelsFromTargetClient = (targetClient,feeScheduleId,labelId) => {
    return fetch(`${SERVER_URL}/api/v2/cms/feeschedule/rate/validate/${targetClient}/${feeScheduleId}/${labelId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getGlobalFeeScheduleCopyPreview = (feeScheduleId, options = {}) => {
    const { startDate, endDate, state, gpci, locality } = options;
    let api = `${SERVER_URL}/api/v2/cms/globalfeeschedule/${feeScheduleId}/copy-preview?`;
    
    if (startDate) api += `startDate=${startDate}&`;
    if (endDate) api += `endDate=${endDate}&`;
    if (state) api += `state=${state}&`;
    if (gpci) api += `gpci=${gpci}&`;
    if (locality) api += `locality=${locality}&`;

    return fetch(api, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const copyGlobalFeeSchedule = (payload) => {
    return fetch(`${SERVER_URL}/api/v2/cms/globalfeeschedule/copy`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};


export {
    getFeeSchedules,
    createDirectory,
    updateDirectory,
    moveDirectoryOrFeeSchedule,
    getHeirarchy,
    getFeeScheduleDirectoryDependencies,
    deleteFeeScheduleDirectory,
    searchFeeSchedules,
    searchFeeSchedulesFromClient,
    getFeeSchedulesLabelsFromTargetClient,
    validateFeeSchedulesLabelsFromTargetClient,
    getGlobalFeeScheduleCopyPreview,
    copyGlobalFeeSchedule
};